import {ApiSortsDerived} from '@/api/meta/odata';
import {getSuggestions} from '@/api/module/order';
import Suggestion, {ApiSuggestion, SuggestionFilters} from '@/model/Suggestion';
import pinia from '@/plugins/pinia';
import {useSettings} from './settings';
import {createVersionedStorage} from './types';
import {boolToDisplay, toDisplay} from '@/util/store';

// const filterNames: Record<keyof SuggestionFilters, string | null> = {
//   'BuchungNr': 'Buchungs-Nr.',
//   'Erledigt': null,
//   'ErstelltAm$From': 'Datum von',
//   'ErstelltAm$To': 'Datum bis',
//   'ErstelltDurch': 'erstellt durch',
// };

// TODO: Filter und Sortierung reaktivieren
const useSuggestionsStore = createVersionedStorage<
  SuggestionFilters, ApiSortsDerived<ApiSuggestion>, Suggestion[]
>('suggestions', {
  fetchFn: getSuggestions,
  defaultData: [],
  defaultFilters: {
    Erledigt: false,
    get ErstelltDurch() {
      return useSettings(pinia).userShort ?? undefined;
    },
  },
  // defaultLimit: 50,
  defaultSorts: [
    // ['ErstelltAm', ApiSortOrder.Asc],
  ],
  formatter: {
    BuchungNr: toDisplay('Buchungs-Nr.'),
    ErstelltAm$From: toDisplay('Datum von'),
    ErstelltAm$To: toDisplay('Datum bis'),
    ErstelltDurch: toDisplay('erstellt durch'),
    Erledigt: (val) => {
      if (val === undefined) return undefined;
      return boolToDisplay('offen', 'erledigt')(!val);
    },
  },
  // convertFilterToDisplayFn: createConvertFiltersToDisplayFn(
  //     createGetRowFn({
  //       getLabel: ({actualKeys}) => filterNames[actualKeys[0] as keyof SuggestionFilters],
  //     }),
  // ),
});

export default useSuggestionsStore;
